import type { AnchorHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

export enum Style {
  Primary = "Primary",
  Secondary = "Secondary",
  Tertiary = "Tertiary",
}

export enum Size {
  Default = "Default",
  Medium = "Medium",
  Large = "Large",
}

interface Props extends AnchorHTMLAttributes<HTMLAnchorElement> {
  buttonStyle?: Style;
  size?: Size;
}

export default function LinkButton({
  buttonStyle = Style.Secondary,
  size = Size.Default,
  ...props
}: Props) {
  const colorClasses = (): string => {
    switch (buttonStyle) {
      case Style.Primary:
        return "bg-violet-600 hover:bg-violet-500 text-white";
      case Style.Tertiary:
        return "hover:bg-slate-100";
      case Style.Secondary:
      default:
        return "bg-slate-100 hover:bg-slate-200";
    }
  };

  const sizeClasses = (): string => {
    switch (size) {
      case Size.Large:
        return "h-14 px-8";
      case Size.Medium:
        return "h-12 px-6";
      case Size.Default:
      default:
        return "h-8 px-4";
    }
  };

  return (
    <a
      {...props}
      className={twMerge(
        ["gap-x-1", "inline-flex", "items-center", "shrink-0"],
        ["font-medium", "nowrap", "text-center"],
        "rounded-md",
        "transition-colors",
        colorClasses(),
        sizeClasses(),
        props.className,
      )}
    >
      {props.children}
    </a>
  );
}
